export const CONTROL_LIMITS = {
  MAX_UNUSED_CONTROLS: 3,
  MAX_HISTORY_STATES: 50,
} as const;
